import styled from 'styled-components';
// framer motion

import { motion } from 'framer-motion';

const ViewBackOffice = styled(motion.div)<{ zoom?: boolean }>`
  margin: 20px 0;
  /* padding-bottom: 70px; */
  position: relative;
  width: 100%;

  @media (min-width: 800px) {
    max-width: 1500px;
    padding: 0 100px;
  }

  ${({ zoom }) =>
    zoom
      ? `
    @media only screen and (max-width: 1500px) and (min-width: 800px) {
      zoom: 80%;
    }
  `
      : ''}
`;

export const AnimatedDashboardWrapper = styled(ViewBackOffice)``;
export const AnimatedItemStyled = styled(motion.div)``;
export const AnimatedTabStyled = styled(motion.div)``;
export const AnimatedAuthStyled = styled(motion.div)``;
